module.exports = __webpack_public_path__ + "static/img/004.4174811c.png";